import { render, staticRenderFns } from "./SectionDisclaimer.vue?vue&type=template&id=337aeb5b&scoped=true"
var script = {}
import style0 from "./SectionDisclaimer.vue?vue&type=style&index=0&id=337aeb5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337aeb5b",
  null
  
)

export default component.exports